/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { TEMP_STORAGE_KEYS } from '../../../constants/main';

/**
 * Remove all the temporary storage keys (mostly authorization related).
 *
 * @returns {void}
 */
export const clearTempStorageKeys = () => {
  for (let key of Object.keys(TEMP_STORAGE_KEYS)) {
    window.localStorage.removeItem(TEMP_STORAGE_KEYS[key]);
  }
};
